export const TEAM_ADMIN_MANAGE_WELLSPACE_PRODUCTS_FLAG = 'TEAM_ADMIN_MANAGE_WELLSPACE_PRODUCTS';
export const ADMIN_SHARED_SHELL_FLAG = 'ADMIN_SHARED_SHELL';
export const TEAM_ADMIN_NATIVE_TEAM_WORKSPACE_FLAG = 'TEAM_ADMIN_NATIVE_TEAM_WORKSPACE';
export const TEAM_ADMIN_COMPANY_OFFERS_FLAG = 'TEAM_ADMIN_COMPANY_OFFERS';
export const TEAM_ADMIN_MODERN_UX_FLAG = 'TEAM_ADMIN_MODERN_UX_FLAG';
export const TEAM_ADMIN_MANAGED_FEATURE_FLAG_ENVIRONMENT_COMPARISON =
  'TEAM_ADMIN_MANAGED_FEATURE_FLAG_ENVIRONMENT_COMPARISON';
export const TEAM_ADMIN_TRANSACTION_RECONCILIATION_FLAG =
  'TEAM_ADMIN_TRANSACTION_RECONCILIATION';
